import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import './Layout.scss';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <Container fluid className="forest-background full-height">
      <Row>
        <Col>
          <div className="layout">
            <header className="header">
              <h1 className="display-4 mb-4 white-stroke">
                ヒーリングサロン Gundari
              </h1>
            </header>

            <main>{children}</main>

            <footer className="footer">
              <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <p className="white-stroke">
                    © 2025 Healing Salon Gundari. All rights reserved.
                  </p>
                  <div className="legal-links">
                    <Link to="/privacy-policy" className="me-3">
                      プライバシーポリシー
                    </Link>
                    {/* <Link to="/legal" className="me-3">
                      特定商取引法
                    </Link> */}
                    <Link to="/terms-of-service" className="me-3">
                      利用規約
                    </Link>
                  </div>
                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <Link to="/login">管理者用ログイン</Link>
                </Col>
              </Row>
            </footer>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
